import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/modules/shared/ui/components/card";
import { Badge } from "@/modules/shared/ui/components/badge";

interface SalaryIncreasePlaceholderProps {
  title: string;
  description: string;
}

// Temporary shell shared by every Salary Increase page until the real
// screens are built out.
export function SalaryIncreasePlaceholder({
  title,
  description,
}: SalaryIncreasePlaceholderProps) {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4 space-y-6">
      <div>
        <h1 className="text-2xl font-semibold flex items-center gap-2">
          {title}
          <Badge variant="secondary">Coming soon</Badge>
        </h1>
        <p className="text-sm text-muted-foreground mt-1">{description}</p>
      </div>
      <Card className="bg-card border shadow-sm">
        <CardHeader>
          <CardTitle className="text-lg">Under construction</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          This page is a placeholder for the Salary Increase module.
        </CardContent>
      </Card>
    </div>
  );
}
